import { useEffect } from 'react';
import ManageMembersContent from '@/app/Domain/components/ManageMembersContent';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import IconAlert from '@/components/common/IconAlert';
import useDomain from '@/hooks/useDomain';
import { Card, Col, Row } from 'react-bootstrap';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { useOutletContext } from 'react-router-dom';
import { breakpointsMediaQuery, useMediaQuery } from '@/helpers/utils';
import type { SettingsOutletContext } from '../index';

const DomainAccess = () => {
  const { domain_slug, domain } = useDomain();
  const { data: userInfo, isLoading } = useGetUserInfoQuery();
  const [, setBreadcrumbData] = useOutletContext<SettingsOutletContext>();
  const isSmUp = useMediaQuery(breakpointsMediaQuery.sm);

  useEffect(() => {
    setBreadcrumbData([{ text: 'مدیریت دسترسی', href: '#' }]);
  }, [setBreadcrumbData]);

  const Result = () =>
    isLoading ? (
      ''
    ) : userInfo?.data?.domains.find(
        (item: { slug: string; access_level: number }) =>
          item.slug === domain_slug
      )?.access_level === 1 ? (
      <ManageMembersContent domain_slug={domain_slug} />
    ) : (
      <IconAlert variant="warning">
        شما مالک این دامنه نیستید. تنها مالک دامنه اجازه دسترسی به مدیریت
        کاربران رو داره
      </IconAlert>
    );

  return (
    <Row className="g-0 justify-content-center">
      <Col>
        {isSmUp ? (
          <Card className="">
            <FalconCardHeader
              titleTag="h5"
              className="py-3"
              light
              title={
                <>
                  مدیریت دسترسی دامنه &nbsp;
                  <strong>{domain}</strong>
                </>
              }
            />
            <Card.Body>
              <Result />
            </Card.Body>
          </Card>
        ) : (
          <Result />
        )}
      </Col>
    </Row>
  );
};

export default DomainAccess;
